import React from "react";
import { Instagram, Phone, Mail } from "lucide-react";

const LOGO_URL = "/aloma-logo.png";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#005EB8] text-white border-t-2 border-[#FFF44F] overflow-hidden"
    >
      <div className="absolute top-0 left-0 right-0 h-2 hazard-stripes" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        {/* Massive brand */}
        <div className="border-b border-[#2989DD] pb-10 mb-10 flex items-center gap-6 flex-wrap">
          <img
            src={LOGO_URL}
            alt="Alambrados Aloma"
            className="h-20 md:h-28 w-auto object-contain"
            style={{ filter: "brightness(1.1) drop-shadow(0 2px 6px rgba(0,0,0,0.4))" }}
          />
          <h2 className="font-display text-6xl sm:text-7xl md:text-[8rem] lg:text-[10rem] leading-[0.85] tracking-tighter">
            ALAMBRADOS <span className="text-[#FFF44F]">ALOMA.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <p className="font-mono-tag text-xs text-[#FFF44F] mb-3">// EMPRESA</p>
            <p className="text-zinc-400 leading-relaxed max-w-md">
              Más de 20 años fabricando e instalando seguridad perimetral y
              herrería metálica con cobertura nacional. Calidad, precisión y
              compromiso en cada proyecto.
            </p>
          </div>
          <div>
            <p className="font-mono-tag text-xs text-[#FFF44F] mb-3">// CONTACTO</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+523223842690"
                  data-testid="footer-phone"
                  className="flex items-center gap-2 text-zinc-300 hover:text-[#FFF44F] link-underline transition-colors"
                >
                  <Phone size={14} /> 322 384 2690
                </a>
              </li>
              <li>
                <a
                  href="mailto:ventas@alambradosaloma.com"
                  data-testid="footer-email"
                  className="flex items-center gap-2 text-zinc-300 hover:text-[#FFF44F] link-underline transition-colors break-all"
                >
                  <Mail size={14} /> ventas@alambradosaloma.com
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono-tag text-xs text-[#FFF44F] mb-3">// SOCIAL</p>
            <a
              href="https://www.instagram.com/alambradosaloma?igsh=NzRsc3RzeXVqc2pp"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-zinc-300 hover:text-[#FFF44F] link-underline transition-colors"
            >
              <Instagram size={14} /> Instagram
            </a>
          </div>
        </div>

        <div className="border-t border-[#333] pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-zinc-500">
          <p>© {year} Alambrados Aloma. Todos los derechos reservados.</p>
          <p className="font-mono-tag tracking-widest">
            SEGURIDAD · PRECISIÓN · COMPROMISO
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
